
import request from '@/common/ajax'
import $  from 'jquery';
import $config  from '../config/config';
import $apis    from './api';   


export default{
     /**
      *
      *  零售报表-客户关怀报表接口
      *
      */
    getCustCareReport(data){
        return request('api/salesReport/custCareReport',data||{},'GET')
    },
      /**
      *
      *  零售报表-购买记录
      *
      */
     getSoldDailyBuyRecords(data){
        return   $apis.sendSync('api/salesReport/soldDailyBuyRecords',data,'GET')           
    },
     /**
      *
      *  零售报表-旧客列表
      *
      */
     getSoldDailyOldCustList(data){
        return   $apis.sendSync('api/salesReport/soldDailyOldCustList',data,'GET')        
    },
     /**
      *
      *  零售报表-新客列表
      *
      */
     getSoldDailyNewCustList(data){
        return   $apis.sendSync('api/salesReport/soldDailyNewCustList',data,'GET')
    },
     /**
      *
      *  零售报表-概况统计
      *
      */
     getSoldDailyBasic(data){
        return request('api/salesReport/soldDailyBasic',data||{},'GET')
    },
     /**
      *
      *  零售报表-产品一级分类销售金额统计(查询)
      *
      */
     getQueryProd1st(data){
        return request('api/prodReport/queryProd1st',data||{},'GET')
    },
     /**
      *
      *  零售报表-产品一级分类销售金额统计(饼图)
      *
      */
     getQuery1stByUserId(data){
        return request('api/prodReport/query1stByUserId',data||{},'GET')
    },

     /**
      *
      *  零售报表-产品一级分类销售金额统计(条形图)
      *
      */
     getProdReportQuery1stByProd(data){
        return request('api/prodReport/query1stByProd',data||{},'GET')
    },
     /**
      *
      *  零售报表-产品二级分类销售金额统计（查询）
      *
      */
     getProdReportQuery2nd(data){
        return request('api/prodReport/query2nd',data||{},'GET')
    },
      /**
      *
      *  零售报表-产品二级分类销售金额统计（饼图）
      *
      */
     getProdReportQuery2ndByUserId(data){
        return request('api/prodReport/query2ndByUserId',data||{},'GET')
    },
      /**
      *
      *  零售报表-产品二级分类销售金额统计（条形图）
      *
      */
     getProdReportQuery2ndByProd(data){
        return request('api/prodReport/query2ndByProd',data||{},'GET')
    },
       /**
      *
      *  零售报表-产品一级二级分类销售数量统计（查询)
      *
      */
     getProdReportQuery1stAnd2nd(data){
        return request('api/prodReport/query1stAnd2nd',data||{},'GET')
    },
       /**
      *
      *  零售报表-产品一级二级分类销售金额统计（饼图)
      *
      */
     getProdReportQuery1stAnd2ndByP1(data){
        return request('api/prodReport/query1stAnd2ndByP1',data||{},'GET')
    },
       /**
      *
      *  零售报表-客户兴趣爱好分类统计表
      *
      */
     getProdReportHobbyClassify(data){
        return request('api/salesReport/hobbyClassify',data||{},'GET')
    },
       /**
      *
      *  零售报表-客户意向课程分类统计表
      *
      */
     getProdReportCourseClassify(data){
        return request('api/salesReport/courseClassify',data||{},'GET')
    },
       /**
      *
      *  零售报表-客户摄影主题分类统计表
      *
      */
     getProdReportShootingTypeClassify(data){
        return request('api/salesReport/shootingTypeClassify',data||{},'GET')
    },
       /**
      *
      *  零售报表-客户所在城市分类统计表
      *
      */
     getProdReportCityClassify(data){
        return request('api/salesReport/cityClassify',data||{},'GET')
    },
    /**
     *
     *  客户关怀表-经销商查询
     *
     */
    getDealerList(data){
      return request('api/dealer/list',data||{},'GET')
    },
  /**
     *
     *  客户关怀报-经销商查询
     *
     */
   custCareReport(data){
      return request('api/salesReport/custCareReport',data||{},'GET')
    },
}



// WEBPACK FOOTER //
// ./src/api/report.js